import React, { useEffect, useState, useRef } from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import logo from '../../../assets/images/logos/Logo-04.png';
import introVideo from '../../../assets/videos/intro-HD-EN-sub.mp4'

const HeroSection = () => {
    return (
        <>
        <Box
            sx={{
            position: 'absolute',
            height: { xs: '1080px', lg: '860px' },
            maxHeight: '860px',
            inset: 0,
            background: 'url("/hero-background.png") no-repeat center/cover',
            zIndex: 0,
            backgroundPosition: { xs: 'center', lg: ''}
            }}
        />

        <Container sx={{ zIndex: 1, position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 0 }}>
            <Box
                sx={{
                    width: { xs: "100%", xxl: "70%" },
                    margin: "0 auto",
                    textAlign: "center"
                }}
            >
                <Box 
                    component="img" 
                    src={logo} 
                    alt="Logo"
                    sx={{ 
                        height: { xs: 65, xxl: 100 }, 
                    }} 
                />
                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: 'bold',
                        fontSize: { xs: "26px", xxl: "48px" },
                        lineHeight: 1.5,
                        color: '#fff',
                    }}
                >
                    De la investiții “pe ghicite” la investiții profitabile
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        color: '#fff',
                        fontWeight: 500, 
                        fontSize: { xs: "14px", xxl: "21px" }, 
                        lineHeight: "28px", 
                        letterSpacing: "normal", 
                    }}
                >
                    Transformă reacțiile impulsive în strategii calculate, cu metodologii clare, alături de investitori activi în imobiliare, piețe financiare, criptomonede, artă și business
                </Typography>


                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: { xs: "column", xxl: "row" }, gap: 2, mb: { xs: 3, xxl: 4 }, mt: { xs: 3, xxl: 4 } }}>
                    <Button
                        href="/contact"
                        variant="contained"
                        sx={{
                        width: { xs: "50%", xxl: "245px" },
                        fontSize: { xs: '12px', xxl: '18px' },
                        fontWeight: 'bold',
                        backgroundColor: '#fff',
                        borderRadius: '16px',
                        textTransform: "none",
                        color: '#1a2b4c',
                        '&:hover': { backgroundColor: '#f0f0f0' },
                        }}
                    >
                        Intră în comunitate
                    </Button>
                </Box>
            </Box>

            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    maxWidth: 686,
                    aspectRatio: '16 / 9',
                    borderRadius: 4,
                    overflow: 'hidden',
                    boxShadow: "0px 8px 24px -2px rgba(0, 0, 0, 0.5)",
                }}
            >
                <video
                  id="intro-video"
                  width="100%"
                  height="100%"
                  controls
                  autoPlay
                  muted={true}
                  playsInline
                >
                  <source src={introVideo} type="video/mp4" />
                </video>
            </Box>
        </Container>
        </>
    );
};

export default HeroSection;